const customNames = [
  { name: 'Company Name', value: 'companyName' },
  { name: 'Status', value: 'status' },
  { name: 'Date Time', value: 'dateTime' },
];

export default customNames;
